/**
 * 缓存失效提示文案（统一管理）
 * 下钻/下载目标页读取不到缓存（服务端缓存被清理、本地缓存过期）时的通知提示与兜底 UI 文案。
 * 中文状态展示中文，英文状态展示英文。
 */

/** 缓存失效场景 */
export type TCacheExpiredScene = 'drilldown' | 'download';

type TLocaleText = { zh: string; en: string };

/** 缓存失效提示文案（一句话） */
export const CACHE_EXPIRED_TEXT: Record<TCacheExpiredScene, TLocaleText> = {
  drilldown: {
    zh: '缓存已失效，请返回原页面重新下钻。',
    en: 'The cache has expired. Please return to the original page and drill down again.',
  },
  download: {
    zh: '缓存已失效，请返回原页面重新获取链接。',
    en: 'The cache has expired. Please return to the original page and retrieve the link again.',
  },
};

/** 兜底 UI「返回首页」按钮文案 */
// export const CACHE_EXPIRED_BACK_HOME: TLocaleText = {
//   zh: '返回首页',
//   en: 'Back to Home',
// };

/** 获取当前语言的缓存失效提示文案 */
export function getCacheExpiredText(
  scene: TCacheExpiredScene,
  isEn: boolean,
): string {
  const text = CACHE_EXPIRED_TEXT[scene];
  return isEn ? text.en : text.zh;
}

/** 获取当前语言的「返回首页」按钮文案 */
// export function getBackHomeText(isEn: boolean): string {
//   return isEn ? CACHE_EXPIRED_BACK_HOME.en : CACHE_EXPIRED_BACK_HOME.zh;
// }
